<template>
  <v-form class="ml-2" @submit.prevent="loadData">
    <v-row>
      <v-col cols="12" class="pb-0">
        <v-subheader light class="pa-0 mb-0 mx-0 form-subheader"
        >Status
        </v-subheader>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12">
        <v-checkbox
            v-for="(bs, index) in LogStatus"
            :key="'bs-' + index"
            v-model="searchform.LogStatus"
            :label="bs.label"
            :value="bs.value"
            :class="'pt-1 ' + (index == 0 ? 'mt-2' : 'mt-0')"
            height="1"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" class="pb-0">
        <v-subheader light class="pa-0 mb-0 mx-0 form-subheader"
        >Créateur
        </v-subheader>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" class="pt-0">
        <smart-multi-select
            :default-select-all="false"
            :items="selectorCommercial"
            style="margin-top: 22px"
            item-text="name"
            item-value="id"
            label="Créateur"
            v-model="searchform.selectorCommercial"
        >
        </smart-multi-select>
      </v-col>
      <v-col cols="12" class="pb-0">
        <v-subheader light class="pa-0 mb-0 mx-0 form-subheader"
        >Destinataire
        </v-subheader>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" class="pt-0">
        <smart-select
            :allIsSameAsEmpty="true"
            class="pa-0"
            :items="selectorCommercial"
            style="margin-top: 22px"
            item-text="name"
            item-value="id"
            label="Destinataire"
            v-model="searchform.selectorRecipient"
        >
        </smart-select>
      </v-col>
      <v-col cols="12">
        <smart-btn type="submit" :loading="loading" :disabled="loading" block primary
        >Rechercher
        </smart-btn
        >
        <smart-btn
            @click.native="clearSearchForm()"
            block
            tertiary
            class="mt-1"
        >Réinitialiser la recherche
        </smart-btn
        >
      </v-col>
    </v-row>

  </v-form>

</template>
<script>
import {get} from "@/utils/api";
import {EventBus} from "@/components/commons/event-bus";
import SmartSelect from "@/components/commons/SmartSelect.vue";
import SmartMultiSelect from "@/components/commons/SmartMultiSelect.vue";

export default {
  name: "CommercialLogListDrawer",
  components: {SmartSelect, SmartMultiSelect},
  data() {
    return {
      openEventEditor: false,
      openConfirmValidate: false,
      statusToSet: null,
      selectorAgents: [],
      agents: [],
      dataReport: null,
      LogStatus: [
        {value: "toreview", label: "Review"},
        {value: "validated", label: "Validé"},
        {value: "pending", label: "En attente"},
      ],
      searchform: {
        LogStatus: ["toreview"],
        selectorCommercial: [],
        selectorRecipient: []
      },
      selectorCommercial: [],
      loading: false
    }
  },
  async created() {
    await this.init(true)
  },
  methods: {
    async init(setCommercial) {
      await this.getCommercials()
      if (setCommercial) {
        this.setCommercial()
      }
      this.loadData()
    },
    clearSearchForm() {
      this.searchform.LogStatus = ["toreview"]
      this.setCommercial()
      this.loadData()
    },
    loadData() {
      EventBus.$emit("loading-visited", this.searchform)
    },
    setCommercial() {
      if (this.currentUser.roles.some(role => role.id == 3)) {
        if (this.currentUser.id != 89) {
          this.searchform.selectorCommercial = []
          this.searchform.selectorRecipient = []
          this.searchform.selectorCommercial.push(this.currentUser.id)
          this.searchform.selectorRecipient.push(this.currentUser.id)
        } else {
          this.searchform.selectorCommercial = []
          this.searchform.selectorRecipient = []
        }
      } else {
        this.searchform.selectorCommercial = []
        this.searchform.selectorRecipient = []
      }
    },

    async getCommercials() {
      await get("/api/search/commercials").json((data) => {
        this.selectorCommercial = data
      })
    },
  }
}
</script>